module.exports = __webpack_public_path__ + "static/img/us.631f7ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/us.jpg
// module id = nBDC
// module chunks = 0